import React, { createContext, useEffect, useContext, useState, useCallback } from 'react';
import { useCreateSubscriptionContext } from './createSubscriptionContext';

export const CONTEXT_KEYS = {
  LOADING_DESIGN: 'LOADING_DESIGN',
  ENABLE_PAGE_OVERFLOW: 'ENABLE_PAGE_OVERFLOW',
  ENABLE_EDITABLE_DESIGN: 'ENABLE_EDITABLE_DESIGN',
  ENABLE_RULER: 'ENABLE_RULER',
  PAGE_LAYOUT_VISIBLE: 'PAGE_LAYOUT_VISIBLE',
  ELEMENT_SETTINGS_VISIBLE: 'ELEMENT_SETTINGS_VISIBLE',
  BLOCK_SETTINGS_VISIBLE: 'BLOCK_SETTINGS_VISIBLE',
  CURRENT_BLOCK_SETTINGS: 'CURRENT_BLOCK_SETTINGS',
  CURRENT_PAGE: 'CURRENT_PAGE',
  CURRENT_BLOCK: 'CURRENT_BLOCK',
  CURRENT_BLOCK_TYPE: 'CURRENT_BLOCK_TYPE',
  SWITCH_CREATIVE_DESIGN_MENU: 'SWITCH_CREATIVE_DESIGN_MENU',
  SCALING_SETTING: 'SCALING_SETTING',
  ADD_ELEMENT_TO_CREATIVE_BLOCK: 'addElementToCreativeBlock',
  AI_LOADER : 'AI_LOADER',
  TEXT_ELEMENT_REF : 'TEXT_ELEMENT_REF',
  RADIO_BUTTONS_RENDER: 'RADIO_BUTTONS_RENDER',
  STATIC_TABLE:'STATIC_TABLE',
  CURRENT_STATIC_TABLE_UPDATE: 'CURRENT_STATIC_TABLE_UPDATE',
  CURRENT_DESIGN: 'CURRENT_DESIGN',
  TEMPLATE_LOCKED: 'TEMPLATE_LOCKED',
  LOCKED_USER_ID: 'LOCKED_USER_ID',
  FLOW_EDIT_MODE: "FLOW_EDIT_MODE",
  RULER_WIDTH_ADJUSTER:"RULER_WIDTH_ADJUSTER",
  DND_FLOW:'DND_FLOW',
  PREVIEW_MODAL: 'PREVIEW_MODAL',
  REUSABLE_ASSET_MODAL:'REUSABLE_ASSET_MODAL',
  CONFIMATION_PAGE_MODAL:"CONFIMATION_PAGE_MODAL",
  PREVIEW_MODAL_DETAILS: 'PREVIEW_MODAL_DETAILS',
  REUSABLE_TYPE:'REUSABLE_TYPE',
  SELECTED_BLOCKS: 'SELECTED_BLOCKS',
  SELECTED_BLOCKS_PARENT: 'SELECTED_BLOCKS_PARENT',
  HEADER_OR_FOOTER_BLOCK_SELECTED: 'HEADER_OR_FOOTER_BLOCK_SELECT',
  CONTENT_BLOCK_SELECTED: 'CONTENT_BLOCK_SELECTED',
  PREVIEW_AND_DOWNLOAD:'PREVIEW_AND_DOWNLOAD',
  STANDALONE_BLOCK_EDIT: 'STANDALONE_BLOCK_EDIT',
  IS_PREVIEW: 'IS_PREVIEW',
  SELECTED_TEMPLATE_PAGES_IN_SIDEBAR_DND: 'SELECTED_TEMPLATE_PAGES_IN_SIDEBAR_DND',
  UPGRADE_MODAL_INFO: 'UPGRADE_MODAL_INFO',
  PREVIEW_PAGE_NUMBER: 'PREVIEW_PAGE_NUMBER',
  BLOCK_DESIGN: 'BLOCK_DESIGN',
  TOC_MODAL_INFO: 'TOC_MODAL_INFO',
  GENERATING_PDF: 'GENERATING_PDF',
  IS_DOC_TO_MAIL: 'IS_DOC_TO_MAIL',
  CHECK_ACCESSIBILITY: 'CHECK_ACCESSIBILITY',
  DISABLE_VARIABLE_MENTION: 'DISABLE_VARIABLE_MENTION',
  ENABLED_ACCESSIBILITY_PREVIEW: 'ENABLED_ACCESSIBILITY_PREVIEW',
  IS_INTERACTIVE_DESIGN: 'IS_INTERACTIVE_DESIGN',
  BLOCK_NAVIGATE_AND_HIGHLIGHT: 'BLOCK_NAVIGATE_AND_HIGHLIGHT',
  CURRENT_BLOCK_ID:'CURRENT_BLOCK_ID',
  CURRENT_FLOW_ID:'CURRENT_FLOW_ID',
  IS_OPEN_DESIGN: 'IS_OPEN_DESIGN',
  SHOW_SIGNUP_PROMPT: 'SHOW_SIGNUP_PROMPT',
  OPEN_MASTER_CLONE: 'OPEN_MASTER_CLONE',
  CURRENT_FLOW_ID:'CURRENT_FLOW_ID',
  GROUP_NAME_MODAL:'GROUP_NAME_MODAL',
  GROUP_ACTION_ITEM:'GROUP_ACTION_ITEM',
  BUSINESS_LOGIC_MODAL: 'BUSINESS_LOGIC_MODAL',
  GROUPED_ELEMENT_IDS: 'GROUPED_ELEMENT_IDS',
  CURRENT_BLOCK_ID: 'CURRENT_BLOCK_ID',
  TOGGLE_TAB_MENU: 'TOGGLE_TAB_MENU',
  BLOCK_SETTINGS_ACTIVE_TAB:'BLOCK_SETTINGS_ACTIVE_TAB',
  ARTBOARD_VERSION: 'ARTBOARD_VERSION',
  READONLY_TEMPLATE: 'READONLY_TEMPLATE',
  IS_DRAFT_EDITABLE: 'IS_DRAFT_EDITABLE',
  REPLACE_DESIGN_CALLBACK: 'REPLACE_DESIGN_CALLBACK',
  IS_HYBRID_MAIL: 'IS_HYBRID_MAIL',
  SELECTED_ENVELOPE_TYPE: 'SELECTED_ENVELOPE_TYPE',
  DELIVERY_CLASS: 'DELIVERY_CLASS',
  STATIONERY: 'STATIONERY'
}

const INITIAL_STATE = () => ({
  [CONTEXT_KEYS.LOADING_DESIGN]: true,
  [CONTEXT_KEYS.ENABLE_PAGE_OVERFLOW]: false,
  [CONTEXT_KEYS.PAGE_LAYOUT_VISIBLE]: false,
  [CONTEXT_KEYS.ELEMENT_SETTINGS_VISIBLE]: false,
  [CONTEXT_KEYS.BLOCK_SETTINGS_VISIBLE]: false,
  [CONTEXT_KEYS.CURRENT_BLOCK_SETTINGS]: null,
  [CONTEXT_KEYS.CURRENT_PAGE]: '',
  [CONTEXT_KEYS.CURRENT_BLOCK]: '',
  [CONTEXT_KEYS.CURRENT_BLOCK_TYPE]: '',
  [CONTEXT_KEYS.SWITCH_CREATIVE_DESIGN_MENU]: false,
  [CONTEXT_KEYS.SCALING_SETTING]: 1,
  [CONTEXT_KEYS.ADD_ELEMENT_TO_CREATIVE_BLOCK]: undefined,
  [CONTEXT_KEYS.AI_LOADER]: false,
  [CONTEXT_KEYS.TEXT_ELEMENT_REF]:null,
  [CONTEXT_KEYS.RADIO_BUTTONS_RENDER]: false,
  [CONTEXT_KEYS.STATIC_TABLE]: null,
  [CONTEXT_KEYS.CURRENT_STATIC_TABLE_UPDATE]: null,
  [CONTEXT_KEYS.ENABLE_EDITABLE_DESIGN]: true,
  [CONTEXT_KEYS.ENABLE_RULER]: true,
  [CONTEXT_KEYS.CURRENT_DESIGN]: '' , 
  [CONTEXT_KEYS.TEMPLATE_LOCKED]: false,
  [CONTEXT_KEYS.LOCKED_USER_ID]: null,
  [CONTEXT_KEYS.FLOW_EDIT_MODE]:'',
  [CONTEXT_KEYS.RULER_WIDTH_ADJUSTER]: false,
  [CONTEXT_KEYS.DND_FLOW]: false,
  [CONTEXT_KEYS.PREVIEW_MODAL]:false,  
  [CONTEXT_KEYS.REUSABLE_ASSET_MODAL]:false, 
  [CONTEXT_KEYS.CONFIMATION_PAGE_MODAL]:false, 
  [CONTEXT_KEYS.PREVIEW_MODAL_DETAILS]: {},
  [CONTEXT_KEYS.REUSABLE_TYPE]: '',
  [CONTEXT_KEYS.SELECTED_BLOCKS]: [],
  [CONTEXT_KEYS.SELECTED_BLOCKS_PARENT]:'',
  [CONTEXT_KEYS.HEADER_OR_FOOTER_BLOCK_SELECTED]: false,
  [CONTEXT_KEYS.CONTENT_BLOCK_SELECTED]: false,
  [CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD]:false, 
  [CONTEXT_KEYS.STANDALONE_BLOCK_EDIT]: '',
  [CONTEXT_KEYS.IS_PREVIEW]: false,
  [CONTEXT_KEYS.SELECTED_TEMPLATE_PAGES_IN_SIDEBAR_DND]: undefined,
  [CONTEXT_KEYS.UPGRADE_MODAL_INFO]: {},
  [CONTEXT_KEYS.PREVIEW_PAGE_NUMBER]: 1,
  [CONTEXT_KEYS.BLOCK_DESIGN]: undefined,
  [CONTEXT_KEYS.TOC_MODAL_INFO]:{},
  [CONTEXT_KEYS.GENERATING_PDF]: false,
  [CONTEXT_KEYS.IS_DOC_TO_MAIL]: false,
  [CONTEXT_KEYS.CHECK_ACCESSIBILITY]: false,
  [CONTEXT_KEYS.DISABLE_VARIABLE_MENTION]: false,
  [CONTEXT_KEYS.ENABLED_ACCESSIBILITY_PREVIEW]: false,
  [CONTEXT_KEYS.IS_INTERACTIVE_DESIGN]: false,
  [CONTEXT_KEYS.BLOCK_NAVIGATE_AND_HIGHLIGHT]: false,
  [CONTEXT_KEYS.CURRENT_BLOCK_ID]:'',
  [CONTEXT_KEYS.CURRENT_FLOW_ID]:'',
  [CONTEXT_KEYS.SHOW_SIGNUP_PROMPT]: false,
  [CONTEXT_KEYS.OPEN_MASTER_CLONE]: undefined,
  [CONTEXT_KEYS.IS_OPEN_DESIGN]: false,
  [CONTEXT_KEYS.GROUP_NAME_MODAL]: false,
  [CONTEXT_KEYS.GROUP_ACTION_ITEM]:'',
  [CONTEXT_KEYS.BUSINESS_LOGIC_MODAL]: {},
  [CONTEXT_KEYS.GROUPED_ELEMENT_IDS] : [],
  [CONTEXT_KEYS.CURRENT_BLOCK_ID]:'',
  [CONTEXT_KEYS.TOGGLE_TAB_MENU]: null,
  [CONTEXT_KEYS.BLOCK_SETTINGS_ACTIVE_TAB]:'1',
  [CONTEXT_KEYS.ARTBOARD_VERSION]: '',
  [CONTEXT_KEYS.READONLY_TEMPLATE]: false,
  [CONTEXT_KEYS.IS_DRAFT_EDITABLE]: false,
  [CONTEXT_KEYS.REPLACE_DESIGN_CALLBACK]: undefined,
  [CONTEXT_KEYS.IS_HYBRID_MAIL]: false,
  [CONTEXT_KEYS.SELECTED_ENVELOPE_TYPE]: 'C5',
  [CONTEXT_KEYS.DELIVERY_CLASS]: 1,
  [CONTEXT_KEYS.STATIONERY]: 1
})
 

export const TEMPLATE_TYPE = {
  DOCUMENT : "document",
  FLOW : 'flow',
  BLOCK : 'block'
}

const ComplexArtboardContext = createContext(null);

export const useArtboardContext = (selector, customName = '', debug = false) => {
  const store = useContext(ComplexArtboardContext);
    if (!store) {
    throw new Error('Store not found');
  }

  const [ state, setState ] = useState(selector(store.get()));

  useEffect(() => {
    return store.subscribe(() => {
      setState(previousState => {
        if (debug) {
          console.log("Change in context :: ", customName, selector(store.get()), previousState, previousState === selector(store.get()));
        }
        return selector(store.get(), previousState);
      });
    }, debug ? customName : '');
  }, []);

  useEffect(() => {
    if (debug) console.log("context change reflected in state :: ",customName, state, store.get())
  }, [state, debug, customName]);

  return [state, store.set, store.reset, store.addNewVariable, store.get];
}

const Provider = ({ children, customState, existingDocument = undefined, customName = 'ArtboardContext' }) => {
  const store = useCreateSubscriptionContext(Object.assign({}, INITIAL_STATE(), customState, {
    [CONTEXT_KEYS.SELECTED_TEMPLATE_PAGES_IN_SIDEBAR_DND]: existingDocument
  }), undefined, false, customName);

  store.reset = useCallback(() => {
    store.set(INITIAL_STATE());
  }, []);

    return (
    <ComplexArtboardContext.Provider value={store}>
      {children}
    </ComplexArtboardContext.Provider>
  );
}

export default Provider;